import {Controller, useFormContext} from 'react-hook-form';
import {SVG} from '../../../../../../constants/assetLists';
import {NetworkDetailsFormValues, NetworkNodeFieldPath} from '../../types';
import AppTextInput from '../../../../../../components/common/AppTextInput';

type Props = {
  selectedFieldPath: NetworkNodeFieldPath;
  expanded: boolean;
  onToggle: (id: string) => void;
};

function ContactDetails({selectedFieldPath, expanded, onToggle}: Props) {
  const {control, watch} = useFormContext<NetworkDetailsFormValues>();

  const contacts = watch(`${selectedFieldPath}.contacts`);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="w-[12px] h-[12px]"
          onClick={() => onToggle('contact')}>
          <img
            src={expanded ? SVG.expandIcon : SVG.lessThanIcon}
            alt="caret"
            className="w-full h-full object-contain"
          />
        </button>

        <div className="flex items-center gap-1">
          <span className="text-base font-semibold text-raspberryRed">*</span>
          <p className="text-base font-semibold text-textColor">אנשי קשר</p>
        </div>
      </div>

      {contacts?.length > 0 && expanded && (
        <>
          {contacts.map((_, index) => {
            const isRequired = index === 0;

            return (
              <div className="flex gap-3">
                <Controller
                  control={control}
                  name={`${selectedFieldPath}.contacts.${index}.firstName`}
                  render={({ field, fieldState: { error } }) => (
                    <div className="flex-1">
                      <AppTextInput
                        label="שם"
                        placeholder="שם"
                        className="border-none"
                        required={isRequired}
                        {...field}
                        error={error?.message}
                      />
                    </div>
                  )}
                />

                <Controller
                  control={control}
                  name={`${selectedFieldPath}.contacts.${index}.lastName`}
                  render={({ field, fieldState: { error } }) => (
                    <div className="flex-1">
                      <AppTextInput
                        label="שם משפחה"
                        placeholder="שם משפחה"
                        className="border-none"
                        required={isRequired}
                        {...field}
                        error={error?.message}
                      />
                    </div>
                  )}
                />

                <Controller
                  control={control}
                  name={`${selectedFieldPath}.contacts.${index}.role`}
                  render={({ field, fieldState: { error } }) => (
                    <div className="flex-1">
                      <AppTextInput
                        label="תפקיד בארגון"
                        placeholder="תפקיד בארגון"
                        className="border-none"
                        required={isRequired}
                        {...field}
                        error={error?.message}
                      />
                    </div>
                  )}
                />

                <Controller
                  control={control}
                  name={`${selectedFieldPath}.contacts.${index}.phone`}
                  render={({ field, fieldState: { error } }) => (
                    <div className="flex-1">
                      <AppTextInput
                        label="טלפון"
                        placeholder="טלפון"
                        className="border-none"
                        required={isRequired}
                        {...field}
                        error={error?.message}
                      />
                    </div>
                  )}
                />

                <Controller
                  control={control}
                  name={`${selectedFieldPath}.contacts.${index}.email`}
                  render={({ field, fieldState: { error } }) => (
                    <div className="flex-1">
                      <AppTextInput
                        label="אימייל"
                        placeholder="אימייל"
                        className="border-none"
                        required={isRequired}
                        {...field}
                        error={error?.message}
                      />
                    </div>
                  )}
                />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}

export default ContactDetails;
